import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import Header from '../common/header'
import testProfile from "../common/helpers/test-profile";
import fetchBotStatus from "../common/helpers/fetch-bot-status";
import clearBotStatus from "../common/helpers/clear-bot-status";


const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }
const tableRowStyle = { fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20 }

const Balance = ({ selectedBot, setDisplayStatusSection }) => {
    // const selectedBot = location.state;
    console.log({
        selectedBot
    })

    const [assets, setAssets] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!selectedBot) return;

        setLoading(true);
        fetchBotStatus(selectedBot.id).then(res => {
            let newData = {};

            res.forEach(data => {
                if (data.symbol) {
                    if (!newData[data.symbol]) { newData[data.symbol] = {} };

                    if (data.side === 'buy') {
                        newData[data.symbol].totalBought = data.total_amount
                    } else {
                        newData[data.symbol].totalSold = data.total_amount
                    }
                }

            })
            setAssets(newData);
            setLoading(false);
        }).catch(err => {
            console.log({ err })
            setLoading(false);
        })
    }, [selectedBot])
    return (
        <>
            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div style={{}}>
                        <div onClick={() => { setDisplayStatusSection(false); }} style={{ display: "flex", cursor: "pointer", flexDirection: "row", gap: 10 }}>
                            <div style={{ color: "grey", fontSize: 17, textDecoration: "underline" }}>My bot list {'>'} Advanced {'>'} </div>
                            <div style={{ position: "relative", top: 3 }}>
                                <div style={{ color: "white" }}>{selectedBot.name} {'>'} Status</div>
                                <div style={{ fontSize: 13, color: "grey" }} >{selectedBot.description || '-'}</div>
                            </div>

                        </div>
                    </div>

                    <Button onClick={() => {
                        setLoading(true);
                        clearBotStatus(selectedBot.id).then(() => {
                            setAssets({});
                            setLoading(false);
                        }).catch(err => {
                            console.log({ err })
                            setLoading(false);
                        })
                    }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">Clear All</Button>
                </div>
                <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                        <div style={{ maxHeight: 800, overflowY: "auto", }}>
                            {loading ? <Spin size="large" style={{ marginLeft: 20 }} /> : <table style={{ width: "100%", }}>
                                <tr>
                                    <th style={tableHeaderStyle} >ASSET</th>
                                    <th style={tableHeaderStyle} ></th>
                                    <th style={tableHeaderStyle} >Total Bought</th>
                                    <th style={tableHeaderStyle} >Total Sold</th>
                                    <th style={tableHeaderStyle} >Total</th>
                                </tr>
                                {assets && Object.keys(assets).map((key, index) => {
                                    const quoteAsset = key.split('/')[1];
                                    const total = ((assets[key].totalSold || 0) - (assets[key].totalBought || 0)).toFixed(2);
                                    return <tr>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, width: "60%" }}>{key}</td>
                                        <td style={tableRowStyle}></td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, color: "white" }}>{assets[key]?.totalBought ? `${assets[key]?.totalBought?.toFixed(2)} ${quoteAsset}` : "--"} </td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, color: "white" }}>{assets[key]?.totalSold ? `${assets[key]?.totalSold?.toFixed(2)} ${quoteAsset}` : "--"} </td>
                                        <td style={{ fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20, color: total > 0 ? "#4ca64c" : parseInt(total) !== 0 ? "#ff4c4c" : "white" }}>{total > 0 ? "+" : ""} {isNaN(parseInt(total)) ? "" : total}</td>
                                    </tr>
                                }
                                )}
                                {/* {assets.map(data => {
                                    return <tr>
                                        <td style={tableRowStyle}><div>{data.asset}</div></td>
                                        <td style={tableRowStyle}>{data.walletBalance}</td>
                                        <td style={tableRowStyle}>0</td>
                                        <td style={tableRowStyle}></td>
                                        <td style={tableRowStyle}></td>
                                    </tr>
                                })} */}
                            </table>}

                        </div>

                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

export default Balance;